/**
 * True when a failed `fetch` (or the subsequent body read) represents a
 * transient connectivity / cancellation failure rather than an actionable
 * defect.
 *
 * The browser rejects `fetch` with `TypeError: Failed to fetch`
 * (`status_code: 0` in RUM) when the connection drops, the request is blocked,
 * or the user navigates away mid-download. These recover on retry and are not
 * defects, so the document download/print helpers both *retry* them and the
 * call sites *demote* them out of Error Tracking. HTTP 4xx/5xx surface as
 * `Error("HTTP <status>")` and are intentionally excluded so genuine download
 * defects stay observable.
 */
export function isTransientNetworkError(error: unknown): boolean {
  if (error instanceof TypeError) {
    return true;
  }

  return error instanceof Error && error.message === "Failed to fetch";
}
